'use strict';
const Modal = (function() {
    const cssTransitionDuration = typeof document.documentElement.style.transitionDuration === 'string' ? 'transitionDuration' : 'WebkitTransitionDuration';
    const on = (eventName, container, target, handler) => {
        container.addEventListener(eventName, e => {
            let el = e.target;

            while (el && el !== document) {
                if (el.matches(target)) {
                    handler.call(this, el, e);
                    return;
                }

                el = el.parentNode;
            }
        });
    }

    const root = document.documentElement;
    const body = document.body;
    const vV = 'visualViewport' in window ? window.visualViewport : null;
    let modals = null;

    const init = () => {
        let backdrop = document.createElement('div');

        const modalCloseCallback = (e) => {
            if (e.target === backdrop && modals.length > 0) {
                e.preventDefault();
                modals[modals.length - 1].hide();
            }
        };
        modals = [];
        backdrop.classList.add('modal-backdrop');
        backdrop.addEventListener('touchstart', modalCloseCallback)
        backdrop.addEventListener('mousedown', modalCloseCallback);
        body.appendChild(backdrop);
    };

    return function (el, options) {
        const config = {
            'speed': 300,
            'close': '.close',
            'ios': false,
            'fullscreen': false
        };

        if (options)
            for (const k in config)
                if (options.hasOwnProperty(k))
                    config[k] = options[k];

        const container = typeof el === 'string' ? document.querySelector(el) : el;
        const speed = config['speed'];

        const setLastModal = () => {
            const len = modals.length;
            if (len > 0) {
                root.dataset.currentModal = modals[len - 1].id;
            } else {
                root.dataset.currentModal = null;
            }
        }
        const escape = (e) => {
            if (e.key !== 'Escape') {
                return true;
            }
            e.preventDefault();
            e.stopImmediatePropagation();
            modals[modals.length - 1].hide();
            return false;
        }

        const show = () => {
            const modalsCount = modals.length;
            const isFs = root.classList.contains('is-fullscreen');
            container.dispatchEvent(new Event('modal:show', {'bubbles': true }));
            container.style[cssTransitionDuration] = `${speed}ms`;

            if (modalsCount === 0) {
                root.classList.add('has-modal');
                if (config['ios']) {
                    root.dataset.position = window.scrollY.toString();
                }
            }
            modals.push(context);
            setLastModal();

            stack(1);
            container.classList.add('in');

            setTimeout(() => {
                if (config['fullscreen'] && vV && !isFs) {
                    root.style.setProperty('--viewport-height', Math.round(vV.height) + 'px');
                }

                root.classList.toggle('is-fullscreen', config['fullscreen']);
                if (modalsCount === 0) {
                    body.addEventListener('keydown', escape);
                }
                container.dispatchEvent(new Event('modal:shown', {'bubbles': true }));
            }, speed);
        }
        const hide = () => {
            const modalsCount = modals.length - 1;
            const isFs = root.classList.contains('is-fullscreen');
            const isPrevFs = modalsCount > 0 && modals[modalsCount - 1].config['fullscreen'];
            container.dispatchEvent(new Event('modal:hide', {'bubbles': true}));

            modals.pop();
            setLastModal();

            container.classList.add('out');

            if (modalsCount === 0) {
                root.classList.add('out');
                body.removeEventListener('keydown', escape);
            }
            root.classList.remove('is-fullscreen');


            if (config['ios'] && isFs && !isPrevFs) {
                window.scrollTo(0, root.dataset.position);
            }

            setTimeout(() => {
                stack(-1);
                if (isPrevFs) {
                    if (vV) {
                        root.style.setProperty('--viewport-height', Math.round(vV.height) + 'px');
                    }
                    root.classList.add('is-fullscreen');
                }

                container.classList.remove('in', 'out');

                if (modalsCount === 0) {
                    root.classList.remove('has-modal', 'out');
                }

                container.dispatchEvent(new Event('modal:hidden', {'bubbles': true}));
            }, 300);
        }
        const stack = (direction) => {
            const modalsCount = modals.length;
            const zIndex = 9e5 + (2 * modalsCount);

            root.style.setProperty('--modal-backdrop-z-index', (zIndex - 1).toString());
            if (direction > 0) {
                container.style.zIndex = zIndex.toString();
            } else {
                container.style.removeProperty('z-index');
            }
        }

        const context = {
            'id': el.id,
            'show': show,
            'hide': hide,
            'config': config
        }

        on('click', container, config['close'], function(el, e) {
            e.preventDefault();
            hide();
        });

        if (modals === null)
            init();

        return context;
    }
})();

export default Modal;